<template>
    <video-embed :params="video.type === 'vimeo' && { title: 1 }" :src="video.url" css="embed-responsive-21by9"/>
</template>

<script>
    export default {
        name: "VideoSlide",
        props: {
            video: null,
        },
        data: () => {
            return {
                className: '',
                show: false,
                interval: null,
                mobile: false,
                tablet: false
            }
        },
        watch: {
            image: function() {
                this.getClassName();
            }
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {

        },
        methods: {
            showCaption() {
                if (!this.show) {
                    this.show = true;
                    clearInterval(this.interval);
                    setInterval(() => {
                        this.show = false;
                        clearInterval(this.interval);
                    }, 5000)
                }
            },
            handleResize() {
                this.mobile = false;
                let width = window.innerWidth;
                if (width <= 768) {
                    this.mobile = true;
                    this.maxPadding = 150;
                } else if (width > 768 && width <= 1200) {
                    this.tablet = true;
                    this.maxPadding = 200;
                } else {
                    this.maxPadding = 250;
                }
            },
            getClassName() {
                if (!this.isSingle) {
                    this.className = 'img__project';
                } else {
                    let image = new Image();
                    image.onload = () => {
                        let height = image.naturalHeight;
                        let width = image.naturalWidth;
                        if (height >= 400 && width >= 400) {
                            //get orientation
                            if (height >= width) {
                                //vertical image
                                this.className = 'img__vertical';
                            } else {
                                if (width / height > 1.8) {
                                    //large image
                                    this.className = 'img__horizontal_large';
                                } else {
                                    this.className = 'img__horizontal';
                                }
                            }
                        }
                    };
                    if (this.image.large) {
                        image.src = this.image.large
                    }
                }
            }
        }
    }
</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 250ms ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>

